/**
 * STORE ACL
 */

const state = () => ({
  role: null,
  rules: [],
  targets: [],
});

const mutations = {
  resetAuth(state) {
    state.role = null;
    state.rules = [];
    state.targets = [];
  },
  setRole(state, role) {
    state.role = role;
  },
  setRules(state, data) {
    state.rules = data;
  },

  setTargets(state, data) {
    state.targets = data;
  },
};

const getters = {
  getRole(state) {
    return state.role;
  },

  getRules(state) {
    return state.rules;
  },
  getTargets(state) {
    return state.targets;
  },

  hasTarget: (state) => (target) => {
    try {
      let targets = state.targets.toString();
      let has = targets.split(",").find((t) => t == target);
      return has ? true : false;
    } catch (error) {
      console.error(error);
    }
  },

  hasAction: (state) => (target, action) => {
    try {
      let rules = state.rules[target];
      let has = rules ? rules.find((ac) => ac == action) : undefined;
      return has ? true : false;
    } catch (error) {
      console.error(error);
    }
  },
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
